export default class AdditionalDamages {
    id: number;
    contractLookupId?: number;
    agreementTypeId?: number;
    damageType: string;
    description: string;
    cost?: number;
    costType: string;
    totalCost?: number;
    costApplied: string;
    createdByUserId?: number;
    createdDate?: Date;
    modifiedByUserId?: number;
    modifiedDate?: Date;
}


// WEBPACK FOOTER //
// ./src/models/AdditionalDamages.ts